
import {
    AmountField as _AmountField,
    MessageField as _MessageField,
    SenderNameField as _SenderNameField,
    DenominationField as _DenominationField,
    DeliveryDateField as _DeliveryDateField,
    RecipientNameField as _RecipientNameField,
    RecipientEmailField as _RecipientEmailField,
    BRAND_CODE as _BRAND_CODE,
    AMOUNT_FIELD as _AMOUNT_FIELD,
    IS_SELF_BUY as _IS_SELF_BUY,
    IS_SAVED_ADDRESS as _IS_SAVED_ADDRESS,
    MESSAGE_FIELD as _MESSAGE_FIELD,
    QUANTITY_FIELD as _QUANTITY_FIELD,
    SENDER_NAME_FIELD as _SENDER_NAME_FIELD,
    FACEPLATE_CODE as _FACEPLATE_CODE,
    FACEPLATE_NAME as _FACEPLATE_NAME,
    ADDRESS_HASH_KEY as _ADDRESS_HASH_KEY,
    MESSAGE_MAX_LENGTH as _MESSAGE_MAX_LENGTH,
    SENDER_EMAIL_FIELD as _SENDER_EMAIL_FIELD,
    FACEPLATE_IMAGE as _FACEPLATE_IMAGE,
    RECIPIENT_NAME_FIELD as _RECIPIENT_NAME_FIELD,
    RECIPIENT_EMAIL_FIELD as _RECIPIENT_EMAIL_FIELD,
    DELIVERY_DATE_FIELD as _DELIVERY_DATE_FIELD,
    DELIVERY_METHOD_FIELD as _DELIVERY_METHOD_FIELD,
    LINE_ITEM_MAX_QUANTITY as _LINE_ITEM_MAX_QUANTITY,
    EXPECT_A_GIFT as _EXPECT_A_GIFT,
    SHIPPING_METHOD_TOKEN as _SHIPPING_METHOD_TOKEN,
    SHIPPING_AMOUNT as _SHIPPING_AMOUNT,
    NAME as _NAME
} from './giftCardFields';

import { ShippingMethodSelector } from './ShippingMethodField';


export const AmountField = _AmountField;
export const MessageField = _MessageField;
export const SenderNameField = _SenderNameField;
export const DenominationField = _DenominationField;
export const DeliveryDateField = _DeliveryDateField;
export const RecipientNameField = _RecipientNameField;
export const RecipientEmailField = _RecipientEmailField;
export const ShippingMethodSelect = ShippingMethodSelector;

export const fieldNames = {
    BRAND_CODE: _BRAND_CODE,
    AMOUNT: _AMOUNT_FIELD,
    MESSAGE: _MESSAGE_FIELD,
    IS_SELF_BUY: _IS_SELF_BUY,
    QUANTITY: _QUANTITY_FIELD,
    EXPECT_A_GIFT: _EXPECT_A_GIFT,
    SENDER_NAME: _SENDER_NAME_FIELD,
    FACEPLATE_CODE: _FACEPLATE_CODE,
    FACEPLATE_NAME: _FACEPLATE_NAME,
    SENDER_EMAIL: _SENDER_EMAIL_FIELD,
    FACEPLATE_IMAGE: _FACEPLATE_IMAGE,
    SHIPPING_AMOUNT: _SHIPPING_AMOUNT,
    DELIVERY_DATE: _DELIVERY_DATE_FIELD,
    ADDRESS_HASH_KEY: _ADDRESS_HASH_KEY,
    IS_SAVED_ADDRESS: _IS_SAVED_ADDRESS,
    RECIPIENT_NAME: _RECIPIENT_NAME_FIELD,
    RECIPIENT_EMAIL: _RECIPIENT_EMAIL_FIELD,
    MESSAGE_MAX_LENGTH: _MESSAGE_MAX_LENGTH,
    DELIVERY_METHOD: _DELIVERY_METHOD_FIELD,
    SHIPPING_METHOD_TOKEN: _SHIPPING_METHOD_TOKEN,
    LINE_ITEM_MAX_QUANTITY: _LINE_ITEM_MAX_QUANTITY,
    NAME: _NAME
};

export const BRAND_CODE = _BRAND_CODE;
export const AMOUNT_FIELD = _AMOUNT_FIELD;
export const IS_SAVED_ADDRESS = _IS_SAVED_ADDRESS;
export const IS_SELF_BUY = _IS_SELF_BUY;
export const MESSAGE_FIELD = _MESSAGE_FIELD;
export const QUANTITY_FIELD = _QUANTITY_FIELD;
export const SENDER_NAME_FIELD = _SENDER_NAME_FIELD;
export const FACEPLATE_CODE = _FACEPLATE_CODE;
export const FACEPLATE_NAME = _FACEPLATE_NAME;
export const ADDRESS_HASH_KEY = _ADDRESS_HASH_KEY;
export const MESSAGE_MAX_LENGTH = _MESSAGE_MAX_LENGTH;
export const SENDER_EMAIL_FIELD = _SENDER_EMAIL_FIELD;
export const FACEPLATE_IMAGE = _FACEPLATE_IMAGE;
export const RECIPIENT_NAME_FIELD = _RECIPIENT_NAME_FIELD;
export const RECIPIENT_EMAIL_FIELD = _RECIPIENT_EMAIL_FIELD;
export const DELIVERY_DATE_FIELD = _DELIVERY_DATE_FIELD;
export const DELIVERY_METHOD_FIELD = _DELIVERY_METHOD_FIELD;
export const LINE_ITEM_MAX_QUANTITY = _LINE_ITEM_MAX_QUANTITY;
export const EXPECT_A_GIFT = _EXPECT_A_GIFT;
export const SHIPPING_METHOD_TOKEN = _SHIPPING_METHOD_TOKEN;
export const SHIPPING_AMOUNT = _SHIPPING_AMOUNT;
export const NAME = _NAME;
